import type { AudienceReachabilityPreview } from '@workspace/types';
import { ContactAgentMetricCard } from './ContactAgentMetricCard';

export function CampaignReachFunnel({
  preview,
  channelLabel,
}: {
  preview: AudienceReachabilityPreview;
  channelLabel: string;
}) {
  // El backend ya separa por canal: quienes quedan afuera son los del segmento sin el dato
  // (teléfono válido o email válido). El total "en segmento" los incluye.
  const leftover = preview.missingPhoneCount ?? preview.unreachableCount;
  const other = preview.excludedOtherCount + preview.deferredCount;
  const total = Math.max(preview.afterFiltersCount, preview.reachableCount + leftover + other, 1);
  return (
    <div className='space-y-4'>
      <div className='grid gap-4 sm:grid-cols-3'>
        <ContactAgentMetricCard title='Alcanzables' valueClassName='text-3xl' value={String(preview.reachableCount)} />
        <ContactAgentMetricCard
          title={`Afuera por falta de ${channelLabel}`}
          valueClassName='text-3xl'
          value={String(leftover)}
        />
        <ContactAgentMetricCard title='En segmento' valueClassName='text-3xl' value={String(preview.afterFiltersCount)} />
      </div>
      <div className='flex h-3 overflow-hidden rounded-full bg-muted' aria-hidden>
        <div className='bg-emerald-600' style={{ width: `${barPct(preview.reachableCount, total)}%` }} />
        <div className='bg-amber-500' style={{ width: `${barPct(leftover, total)}%` }} />
        <div className='bg-muted-foreground/30' style={{ width: `${barPct(other, total)}%` }} />
      </div>
      <p className='text-sm text-muted-foreground'>
        {preview.reachableCount} alcanzables. {leftover} quedan afuera por falta de {channelLabel}.
        {other > 0 ? ` ${other} no salen por otra razón.` : ''}
      </p>
    </div>
  );
}

function barPct(value: number, total: number): number {
  if (total <= 0 || value <= 0) {
    return 0;
  }
  return Math.max(2, Math.round((value / total) * 100));
}
